import { render } from "./TextShort.vue?vue&type=template&id=f6380442"
import script from "./TextShort.vue?vue&type=script&lang=js"
export * from "./TextShort.vue?vue&type=script&lang=js"

import exportComponent from "/Users/georgwidschwendter/Documents/GitHub/learn/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__